import { render, staticRenderFns } from "./BackendServerSpec.vue?vue&type=template&id=76f8f57f&"
import script from "./BackendServerSpec.vue?vue&type=script&lang=js&"
export * from "./BackendServerSpec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports